import config from 'config'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { processURLAddress } from '@vue-storefront/core/helpers'
import { coreHooksExecutors } from '@vue-storefront/core/hooks'

export function getPathForStaticPage (path: string) {
  const { storeCode } = currentStoreView()
  const isStoreCodeEquals = storeCode === config.defaultStoreCode

  return isStoreCodeEquals ? `/i${path}` : path
}

export function getMediaThumbnailPath (relativeUrl: string, width: number = 0, height: number = 0, pathType: string = 'product', action: string = 'resize'): string {
  if (config.images.useSpecificImagePaths) {
    const path = config.images.paths[pathType] !== undefined ? config.images.paths[pathType] : ''
    relativeUrl = path + relativeUrl
  }

  if (config.images.useExactUrlsNoProxy) {
    return coreHooksExecutors.afterProductThumbnailPathGenerate({ path: relativeUrl, sizeX: width, sizeY: height, pathType }).path // this is exact url mode
  } else {
    let resultUrl
    if (relativeUrl && (relativeUrl.indexOf('://') > 0 || relativeUrl.indexOf('?') > 0 || relativeUrl.indexOf('&') > 0)) relativeUrl = encodeURIComponent(relativeUrl)
    // proxyUrl is not a url base path but contains {{url}} parameters and so on to use the relativeUrl as a template value and then do the image proxy opertions
    let mediaUrl = processURLAddress(config.images.proxyUrl ? config.images.proxyUrl : config.images.mediaUrl)
    if (mediaUrl.indexOf('{{') >= 0) {
      mediaUrl = mediaUrl.replace('{{url}}', relativeUrl)
      mediaUrl = mediaUrl.replace('{{width}}', width.toString())
      mediaUrl = mediaUrl.replace('{{height}}', height.toString())
      resultUrl = mediaUrl
    } else {
      resultUrl = `${mediaUrl}${action}/${width.toString()}/${height.toString()}${relativeUrl}`
    }
    const path = relativeUrl && relativeUrl.indexOf('no_selection') < 0 ? resultUrl : config.images.productPlaceholder || ''

    return coreHooksExecutors.afterProductThumbnailPathGenerate({ path, sizeX: width, sizeY: height, pathType }).path
  }
}

export function timeout (ms) {
  let timeout, promise

  promise = new Promise(resolve => {
    timeout = setTimeout(() => resolve(), ms)
  })

  return {
    promise,
    cancel: () => clearTimeout(timeout)
  }
}

export function getFullCanonicalHref (path: string): string {
  let storeUrl = config.seo.url
  let finalPath = path

  if (finalPath.startsWith('/')) {
    finalPath = finalPath.slice(1)
  }

  const queryPos = finalPath.indexOf('?')
  if (queryPos > 0) finalPath = finalPath.slice(0, queryPos)
  if (finalPath.endsWith('/')) finalPath = finalPath.slice(0, -1)

  let url = storeUrl + finalPath
  if (url.endsWith('/')) url = url.slice(0, -1)

  return url
}

export function cleanPath (path) {
  if (path.includes('/media/original')) {
    path = path.replace('/media/original', ``)
  }

  return path
}
